import callApiAxiosClient from "../../axios/axios_client";
import moment from "moment";
import { shelfStatusBulkList } from "../../models";


async function bakeryShelfCurrentStatusBulkPagination(user_id: string, date: Date, pageIndex?: number, pageSize?: number, searchText = ""): Promise<shelfStatusBulkList> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const dateParam = moment(date).format("YYYYMMDD");
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<shelfStatusBulkList>({
        method: "get",
        url: "programmability/shelf-current-status-bulk-pagination",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization
        },
        params: {
            user_id: user_id,
            date: dateParam,
            pageIndex: pageIndex,
            pageSize: pageSize,
            searchText: searchText
        }
    })
}
export default bakeryShelfCurrentStatusBulkPagination;